<template>
  <nav class="navbar navbar-expand-lg">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">Panel</a>
      <button type="button" class="navbar-toggler navbar-toggler-right" :class="{toggled: $sidebar.showSidebar}"
        aria-controls="navigation-index" aria-expanded="false" aria-label="Toggle navigation" @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">

        <ul class="navbar-nav ml-auto">


          <li class="nav-item">
            <a @click="logOut()" class="nav-link">
              Çıkış Yap
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  import authorizationService from "../services/authorization.service.js";

  export default {
    computed: {
      routeName() {
        const { name } = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data() {
      return {
        activeNotifications: false
      }
    },
    methods: {
      capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown() {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown() {
        this.activeNotifications = false
      },
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false)
      },
      logOut() {
        console.log(authorizationService)
        authorizationService.logOut()
          .then(response => {
            this.$router.push("/signin")
          }).catch(err => {
            console.log(err)
            console.log({ err })
          })
      }
    }
  }

</script>
<style>

</style>